import { render, staticRenderFns } from "./ConfigurazioniMagazzinoArticoliUmListComponent.vue?vue&type=template&id=e709b7b8"
import script from "./ConfigurazioniMagazzinoArticoliUmListComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioniMagazzinoArticoliUmListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports